<template>
    <v-card outlined max-width="320">
        <v-row no-gutters align="center">
            <v-col cols="auto">
                <v-card-subtitle class="py-0 pr-0"> 회원 </v-card-subtitle>
            </v-col>
            <v-col>
                <autocomplete-member v-model="query['_member']" dense flat solo hide-details clearable @input="emit" />
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import AutocompleteMember from "../dumb/autocompletes/autocomplete-member.vue";

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["_member"]: query?.["_member"] || null,
});

export default {
    components: {
        AutocompleteMember,
    },
    data: () => ({
        query: initQuery(),
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;
            delete query["page"];
            if (!query["_member"]) delete query["_member"];
            this.$router.push({ query });
        },
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    mounted() {
        sync();
    },
};
</script>

<style lang="scss" scoped></style>
